import React from 'react';
import { FiFileText, FiDownload, FiExternalLink, FiCheckCircle } from 'react-icons/fi';
import { useLanguage } from '../../i18n';

export default function ResumeWindow() {
  const { language } = useLanguage();

  return (
    <div className="resume-window-container p-4 text-[#d4dbe1] max-w-xl mx-auto flex flex-col gap-5">
      {/* Header com badge */}
      <div className="flex items-center gap-3 border-b border-[rgba(0,240,255,0.2)] pb-3">
        <div className="w-10 h-10 rounded bg-[rgba(0,240,255,0.1)] border border-[rgba(0,240,255,0.3)] flex items-center justify-center text-[var(--neon-cyan)] text-xl shadow-[0_0_12px_rgba(0,240,255,0.25)]">
          <FiFileText />
        </div>
        <div>
          <h3 className="font-bold text-base text-white tracking-wide font-mono">
            Pedro_Riccio_Curriculo.pdf
          </h3>
          <p className="text-xs text-[var(--neon-cyan)] font-mono">
            {language === 'en' ? 'Software Engineer · Backend & AI Orchestration' : 'Engenheiro de Software · Backend & Orquestração de IA'}
          </p>
        </div>
        <span className="ml-auto px-2 py-0.5 text-[10px] rounded bg-[rgba(0,240,255,0.15)] text-[var(--neon-cyan)] border border-[rgba(0,240,255,0.3)] font-mono uppercase tracking-wider">
          v2026.1
        </span>
      </div>

      {/* Resumo do Perfil */}
      <div className="bg-[#141a21] border border-[rgba(255,255,255,0.08)] rounded p-3 text-xs leading-relaxed space-y-1.5 font-mono">
        <div className="flex items-center gap-1.5 text-emerald-400 font-semibold">
          <FiCheckCircle className="text-xs" />
          <span>{language === 'en' ? 'Verified Professional Profile' : 'Perfil Profissional Verificado'}</span>
        </div>
        <p className="text-[#a3abb5]">
          {language === 'en' 
            ? 'Complete resume covering backend architecture, AI multi-agent systems, MCP, RAG, Linux infrastructure, and B2B industrial software delivery.'
            : 'Currículo detalhado com sólida experiência em arquitetura backend, sistemas multiagente de IA, MCP, RAG, infraestrutura Linux e inteligência comercial B2B.'}
        </p>
      </div>

      {/* Cards de Download */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {/* Versão Português */}
        <div className="bg-[#182028] border border-[rgba(0,240,255,0.2)] rounded p-3 flex flex-col justify-between gap-3 hover:border-[rgba(0,240,255,0.4)] transition-all">
          <div>
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-white font-mono flex items-center gap-1.5">
                🇧🇷 Versão PT-BR
              </span>
              <span className="text-[10px] text-[#8a95a0] font-mono">PDF · A4</span>
            </div>
            <p className="text-[11px] text-[#a3abb5] mt-1">
              Currículo formatado em Português para empresas nacionais e posições remotas no Brasil.
            </p>
          </div>

          <div className="flex items-center gap-2 pt-1">
            <a
              href="/Pedro_Riccio.pdf"
              download="Pedro_Riccio_Curriculo.pdf"
              className="flex-1 flex items-center justify-center gap-1.5 py-1.5 px-3 rounded bg-[var(--neon-cyan)]/15 border border-[var(--neon-cyan)] text-[var(--neon-cyan)] text-xs font-mono font-semibold hover:bg-[var(--neon-cyan)] hover:text-black transition-all shadow-[0_0_10px_rgba(0,240,255,0.2)]"
            >
              <FiDownload />
              <span>Baixar</span>
            </a>
            <a
              href="/Pedro_Riccio.pdf"
              target="_blank"
              rel="noreferrer"
              title="Visualizar em nova aba"
              className="p-1.5 rounded bg-white/5 border border-white/10 text-white/70 hover:text-white hover:bg-white/10 transition-all text-xs"
            >
              <FiExternalLink />
            </a>
          </div>
        </div>

        {/* Versão Inglês */}
        <div className="bg-[#182028] border border-[rgba(168,85,247,0.25)] rounded p-3 flex flex-col justify-between gap-3 hover:border-[rgba(168,85,247,0.45)] transition-all">
          <div>
            <div className="flex items-center justify-between">
              <span className="text-xs font-bold text-white font-mono flex items-center gap-1.5">
                🇺🇸 English Version
              </span>
              <span className="text-[10px] text-[#8a95a0] font-mono">PDF · A4</span>
            </div>
            <p className="text-[11px] text-[#a3abb5] mt-1">
              Resume formatted in English for global remote roles and international contracting.
            </p>
          </div>

          <div className="flex items-center gap-2 pt-1">
            <a
              href="/Pedro_Riccio_EN.pdf"
              download="Pedro_Riccio_Resume_EN.pdf"
              className="flex-1 flex items-center justify-center gap-1.5 py-1.5 px-3 rounded bg-[var(--neon-violet)]/15 border border-[var(--neon-violet)] text-[#c084fc] text-xs font-mono font-semibold hover:bg-[var(--neon-violet)] hover:text-white transition-all shadow-[0_0_10px_rgba(168,85,247,0.2)]"
            >
              <FiDownload />
              <span>Download</span>
            </a>
            <a
              href="/Pedro_Riccio_EN.pdf"
              target="_blank"
              rel="noreferrer"
              title="Open in new tab"
              className="p-1.5 rounded bg-white/5 border border-white/10 text-white/70 hover:text-white hover:bg-white/10 transition-all text-xs"
            >
              <FiExternalLink />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
